import React, {useRef} from 'react';
import {IconButton} from '@wix/wix-ui-tpa/cssVars';
import {ChevronLeft, ChevronRight} from '@wix/wix-ui-icons-common/on-stage';
import {classes} from './Carousel.st.css';

export enum CarouselDataHook {
  root = 'Carousel.root',
  scroller = 'Carousel.scroller',
  item = 'Carousel.item',
  leftArrow = 'Carousel.leftArrow',
  rightArrow = 'Carousel.rightArrow',
}

export const ITEM_GAP = 20;

export interface CarouselProps {
  title: React.ReactNode;
  items: {id: string; content: React.ReactNode}[];
  itemWidth: number;
}

export const Carousel = ({title, items, itemWidth}: CarouselProps) => {
  const scroller = useRef<HTMLUListElement>(null);

  const scrollByItems = (count: number) => {
    scroller.current.scrollLeft += count * (itemWidth + ITEM_GAP);
  };

  return (
    <div data-hook={CarouselDataHook.root} className={classes.root}>
      <div className={classes.header}>{title}</div>
      <div className={classes.scrollArea}>
        <IconButton
          data-hook={CarouselDataHook.leftArrow}
          className={classes.arrow}
          style={{height: itemWidth}}
          icon={<ChevronLeft />}
          onClick={() => scrollByItems(-1)}
        />
        <ul ref={scroller} data-hook={CarouselDataHook.scroller} className={classes.scroller} style={{gap: ITEM_GAP}}>
          {items.map((item) => (
            <li key={item.id} data-hook={CarouselDataHook.item} style={{width: itemWidth}}>
              {item.content}
            </li>
          ))}
        </ul>
        <IconButton
          data-hook={CarouselDataHook.rightArrow}
          className={classes.arrow}
          style={{height: itemWidth}}
          icon={<ChevronRight />}
          onClick={() => scrollByItems(1)}
        />
      </div>
    </div>
  );
};
